// require('dotenv').config()
import axios from "axios";
import Constants from "./constants";
import { include } from "../utils/javascript";
import { Logout, isAuthenticated, logout } from "./auth";

const successStatus = [200, 201, 204];

const api = (method, urlEndPoint, data = null, headers = {}, params = {}) =>
    new Promise((myResolve) => {
        let headers = {
            "Content-Type": "application/json",
        };

        if (isAuthenticated()) {
            headers = {
                ...headers,
                Authorization: `Bearer ${isAuthenticated()}`,
            };
        }

        axios({
            method,
            url: Constants.BASE_URL + urlEndPoint,
            data,
            headers,
            params,
        })
            .then((response) => {
                myResolve({
                    message: response.data.message,
                    data: response.data.data,
                    success: response.data.success,
                    statusCode: include(successStatus, response.status),
                });
            })
            .catch((err) => {
                if (err.response) {
                    myResolve({
                        message: err.response.data.message,
                        data: err.response.data.data,
                        success: err.response.data.success,
                    });
                }
                if (err?.response?.status === 401) {
                    Logout(() => {
                        setTimeout(() => {
                            window.location.href = "/";
                        }, 400);
                    });
                } else {
                    myResolve({
                        message: err.toString(),
                        data: { ...err },
                        success: false,
                    });
                }
            });
    });
const multipartApi = (method, urlEndPoint, data = null) =>
    new Promise((myResolve) => {
        let headers = {
            "Content-Type": "multipart/form-data",
        };

        if (isAuthenticated()) {
            headers = {
                ...headers,
                Authorization: `Bearer ${isAuthenticated()}`,
            };
        }

        axios({
            method,
            url: Constants.BASE_URL + urlEndPoint,
            data,
            headers,
        })
            .then((response) => {
                myResolve({
                    message: response.data.message,
                    data: response.data.data,
                    success: response.data.success,
                    statusCode: include(successStatus, response.status),
                });
            })
            .catch((err) => {
                if (err.response) {
                    myResolve({
                        message: err.response.data.message,
                        data: err.response.data.data,
                        success: err.response.data.success,
                    });
                }
                if (err?.response?.status === 401) {
                    Logout(() => {
                        setTimeout(() => {
                            window.location.href = "/";
                        }, 400);
                    });
                } else {
                    myResolve({
                        message: err.toString(),
                        data: { ...err },
                        success: false,
                    });
                }
            });
    });

export { api, multipartApi };
